import { IDMTargeting } from "@digital-media/ad-model";
import { errorStatus, errorStatusToMessage } from "../utils/errorUtils";
import { objectEntriesToUrlParams, request } from "../utils";
import { idmAccessGroup, idmUserInfo } from "../endpointUrl";
import { filterIDMTargetingParams, IDMResponse } from "../utils/targetingUtils";
import { transformResponseToTargetingObject } from "../mapper/targetingParamsMapper";

export async function getIDMTargetingParameters(
  transactionId: string,
  smartpointEnv: string,
  pcc: string,
  gds: string
): Promise<IDMTargeting> {
  const paramsStr = objectEntriesToUrlParams({ pcc, gds });
  const idmAccessGroupParams = await getIDMAccessGroupInfo(
    transactionId,
    smartpointEnv,
    paramsStr
  );
  const idmUserGTID = await getIDMUserInfo(
    transactionId,
    smartpointEnv,
    paramsStr
  );

  return transformResponseToTargetingObject(idmAccessGroupParams, idmUserGTID);
}

async function getIDMAccessGroupInfo(
  transactionId: string,
  smartpointEnv: string,
  paramsStr: string
) {
  const response = await request(
    `${smartpointEnv}/${idmAccessGroup}${paramsStr}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=utf-8",
        transactionid: transactionId,
      },
    }
  );
  if (errorStatus.includes(response.status)) {
    const body = await response.text();
    throw new Error(body || errorStatusToMessage[response.status]);
  }

  const idmResponse = await response.json();
  const idmAccessGroupInfo: IDMResponse[] =
    idmResponse.accessGroupsInfo[0].AccessGroupSummary.ConfigurationInfo;
  return filterIDMTargetingParams(idmAccessGroupInfo);
}

async function getIDMUserInfo(
  transactionId: string,
  smartpointEnv: string,
  paramsStr: string
) {
  const response = await request(
    `${smartpointEnv}/${idmUserInfo}${paramsStr}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=utf-8",
        transactionid: transactionId,
      },
    }
  );
  if (errorStatus.includes(response.status)) {
    const body = await response.text();
    throw new Error(body || errorStatusToMessage[response.status]);
  }

  const userInfoResponse = await response.json();
  return userInfoResponse.userInfoOd.IdmUserResponse.IdmUser.StaticGTID[0].id;
}
